<div class="ts1-maneuver-breakdown">
	<div class="ts1-maneuver-breakdown__page-header">
		<div>
			<h2 class="ts1-maneuver-breakdown__page-title">{{ summaryReportTitle }}</h2>
			<p class="ts1-maneuver-breakdown__page-subtitle">Maneuver Breakdown</p>
		</div>
	</div>

	@if (maneuvers.length === 0) {
		<div class="ts1-maneuver-breakdown__empty">No maneuver breakdown available.</div>
	} @else {
		@for (maneuver of maneuvers; track maneuver.maneuverCode) {
			<section class="ts1-maneuver-breakdown__maneuver">
				<div class="ts1-maneuver-breakdown__maneuver-banner">
					<span class="ts1-maneuver-breakdown__maneuver-order">{{ formatManeuverOrder(maneuver.order) }}</span>
					<span class="ts1-maneuver-breakdown__maneuver-label">{{ maneuver.label }}</span>
				</div>

				<div class="ts1-maneuver-breakdown__panel">
					<div class="ts1-maneuver-breakdown__columns-header">
						<div class="ts1-maneuver-breakdown__col-header ts1-maneuver-breakdown__col-header--left">
							<div class="ts1-maneuver-breakdown__col-header-row">
								<span class="ts1-maneuver-breakdown__candidate-name">{{ leftCandidateName }}</span>
								<span class="ts1-role-badge ts1-role-badge--pf">{{ leftRoleLabel }}</span>
							</div>
						</div>
						<div class="ts1-maneuver-breakdown__col-header ts1-maneuver-breakdown__col-header--right">
							<div class="ts1-maneuver-breakdown__col-header-row">
								<span class="ts1-maneuver-breakdown__candidate-name">{{ rightCandidateName }}</span>
								<span class="ts1-role-badge ts1-role-badge--pm">{{ rightRoleLabel }}</span>
							</div>
						</div>
					</div>

					<mat-accordion [multi]="true" class="ts1-maneuver-breakdown__accordion ob-selection-accordion">
						@for (section of maneuver.sections; track section.code) {
							<mat-expansion-panel
								class="mat-elevation-z0 ts1-ob-section ts1-maneuver-breakdown__section-panel"
								[expanded]="isSectionExpanded(maneuver.maneuverCode, section)"
								(expandedChange)="onSectionExpandedChange(maneuver.maneuverCode, section.code, $event)"
							>
								<mat-expansion-panel-header class="ts1-ob-section-header ts1-maneuver-breakdown__section-header">
									<mat-panel-title>
										<div class="ts1-maneuver-breakdown__section-header-inner">
											<span
												class="ts1-maneuver-breakdown__section-dot"
												[class.ts1-maneuver-breakdown__section-dot--active]="sectionHasValue(section)"
												aria-hidden="true"
											></span>
											<span class="ts1-maneuver-breakdown__section-name">{{ section.name }}</span>
										</div>
									</mat-panel-title>
									@if (section.selectedCount > 0) {
										<mat-panel-description>
											<span class="ts1-maneuver-breakdown__section-count">{{
												section.selectedCount
											}}</span>
										</mat-panel-description>
									}
								</mat-expansion-panel-header>

								@for (row of sectionRows(section); track $index) {
									<div class="ts1-maneuver-breakdown__ob-row">
										@if (row.pf; as pfObs) {
											<div
												class="ts1-maneuver-breakdown__ob-cell ts1-maneuver-breakdown__ob-cell--left"
												[ngClass]="cellStateClass(pfObs.pf, maneuver.maneuverCode, pfObs.label, CandidateRole.PF)"
											>
												<div class="ts1-maneuver-breakdown__ob-cell-label">
													<span class="ts1-maneuver-breakdown__dot" aria-hidden="true"></span>
													<mat-icon
														class="ts1-maneuver-breakdown__info"
														[matTooltip]="pfObs.description"
														matTooltipPosition="above"
														>info</mat-icon
													>
													<span class="ts1-maneuver-breakdown__ob-label">{{ pfObs.label }}</span>
													@if (showAttemptCount(pfObs.pf)) {
														<span class="ts1-maneuver-breakdown__attempt"
															>[{{ attemptCounts(pfObs.pf).current }}/{{ attemptCounts(pfObs.pf).total }}]</span
														>
													}
												</div>
												<div class="ts1-maneuver-breakdown__ob-cell-actions">
													@if (showPredefinedStar(pfObs.pf)) {
														<img
															class="ts1-maneuver-breakdown__star"
															src="/assets/predefined_stars_teal.svg"
															width="24"
															height="24"
															alt=""
															role="img"
															[attr.aria-label]="predefinedObBadgeTooltip"
															[matTooltip]="predefinedObBadgeTooltip"
															matTooltipPosition="above"
														/>
													}
													@if (shouldHighlightConditionalOb(maneuver.maneuverCode, pfObs.label, CandidateRole.PF)) {
														<img
															class="ts1-maneuver-breakdown__star"
															[src]="conditionalObBadgeSrc"
															width="24"
															height="24"
															alt=""
															role="img"
															[attr.aria-label]="conditionalObBadgeTooltip"
															[matTooltip]="conditionalObBadgeTooltip"
															matTooltipPosition="above"
														/>
													}
													<button
														type="button"
														class="attemptBtn removeBtn"
														disabled
														tabindex="-1"
														aria-hidden="true"
													>
														-
													</button>
													<button
														type="button"
														class="attemptBtn addBtn"
														disabled
														tabindex="-1"
														aria-hidden="true"
													>
														+
													</button>
												</div>
											</div>
										} @else {
											<div
												class="ts1-maneuver-breakdown__ob-cell ts1-maneuver-breakdown__ob-cell--left ts1-maneuver-breakdown__ob-cell--empty"
											></div>
										}

										@if (row.pm; as pmObs) {
											<div
												class="ts1-maneuver-breakdown__ob-cell"
												[ngClass]="cellStateClass(pmObs.pm, maneuver.maneuverCode, pmObs.label, CandidateRole.PM)"
											>
												<div class="ts1-maneuver-breakdown__ob-cell-label">
													<span class="ts1-maneuver-breakdown__dot" aria-hidden="true"></span>
													<mat-icon
														class="ts1-maneuver-breakdown__info"
														[matTooltip]="pmObs.description"
														matTooltipPosition="above"
														>info</mat-icon
													>
													<span class="ts1-maneuver-breakdown__ob-label">{{ pmObs.label }}</span>
													@if (showAttemptCount(pmObs.pm)) {
														<span class="ts1-maneuver-breakdown__attempt"
															>[{{ attemptCounts(pmObs.pm).current }}/{{ attemptCounts(pmObs.pm).total }}]</span
														>
													}
												</div>
												<div class="ts1-maneuver-breakdown__ob-cell-actions">
													@if (showPredefinedStar(pmObs.pm)) {
														<img
															class="ts1-maneuver-breakdown__star"
															src="/assets/predefined_stars_teal.svg"
															width="24"
															height="24"
															alt=""
															role="img"
															[attr.aria-label]="predefinedObBadgeTooltip"
															[matTooltip]="predefinedObBadgeTooltip"
															matTooltipPosition="above"
														/>
													}
													@if (shouldHighlightConditionalOb(maneuver.maneuverCode, pmObs.label, CandidateRole.PM)) {
														<img
															class="ts1-maneuver-breakdown__star"
															[src]="conditionalObBadgeSrc"
															width="24"
															height="24"
															alt=""
															role="img"
															[attr.aria-label]="conditionalObBadgeTooltip"
															[matTooltip]="conditionalObBadgeTooltip"
															matTooltipPosition="above"
														/>
													}
													<button
														type="button"
														class="attemptBtn removeBtn"
														disabled
														tabindex="-1"
														aria-hidden="true"
													>
														-
													</button>
													<button
														type="button"
														class="attemptBtn addBtn"
														disabled
														tabindex="-1"
														aria-hidden="true"
													>
														+
													</button>
												</div>
											</div>
										} @else {
											<div class="ts1-maneuver-breakdown__ob-cell ts1-maneuver-breakdown__ob-cell--empty"></div>
										}
									</div>
								}
							</mat-expansion-panel>
						}
					</mat-accordion>
				</div>
			</section>
		}
	}
</div>
